import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ChargePointUser } from '../../../../common/redux/api/web-api'

const initialState: ChargePointUser = {
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    password: '',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    passwordCompare: '',
    roleInCompany: '',
    userStatus: 'New',
}

export const selectedUserSlice = createSlice({
    name: 'selectedUser',
    initialState,
    reducers: {
        setSelectedUser: (_, action: PayloadAction<ChargePointUser>) => {
            return { ...action.payload }
        },
        resetSelectedUser: () => {
            return { ...initialState }
        },
    },
})

export const { setSelectedUser, resetSelectedUser } = selectedUserSlice.actions

export default selectedUserSlice.reducer
